import { useV3Shell } from './V3ShellContext';
import { useV3Modal } from './useV3Modal';

// One call that turns any window (modal) into a V3 window. `useV3Window(isOpen, wantedWidth, { single })` registers the window with the
// shell (so the shell can push the side bars shut when the room is short; see useV3Modal) and returns what to add to the window's
// overlay element:  className  (the layer over the content area),  style  (where it sits),  attrs  (the theme).
//   single: true  for a window that is just one panel (the panel is the overlay's only child); it is then styled as the V3 window by
//                 the stylesheet alone, so its own markup does not need to change.
// Outside the V3 shell everything it returns is empty, so the window looks and works exactly as before.
export const useV3Window = (open, wantedWidth, options = {}) => {
  const shell = useV3Shell();
  useV3Modal(open, wantedWidth);
  if (!shell) return { active: false, className: '', style: {}, attrs: {} };
  return {
    active: true,
    className: `v3-root v3-modal-region${options.single ? ' v3-modal-region--single' : ''}`,
    style: { ...shell.regionVars, top: shell.regionTop, zIndex: 40, '--v3-win-w': `${wantedWidth}px` },
    attrs: { 'data-v3-theme': shell.theme },
  };
};

export default useV3Window;
